import type { CPollsTranslations } from "./pl";

/** CPolls - English translations (Interactive forms / surveys). */
export const en: CPollsTranslations = {
  emptyData: "No data to display.",
  list: {
    empty: "No surveys to display.",
    fillOut: "Fill out",
    showResults: "Results",
    alreadyFilled: "Completed",
  },
  poll: {
    guestHeading: "Introduce yourself first",
    labels: {
      email: "E-mail address",
      name: "First name",
      surname: "Last name",
      telephone: "Phone",
      justification: "Reason for the answer",
    },
    back: "Back to surveys",
    next: "Next",
    end: "Finish",
    submitting: "Saving...",
    alreadyFilled: "This survey has already been completed by this user.",
    rankingHint: "Drag the items or use the arrows to set the order.",
    moveUp: "Move up",
    moveDown: "Move down",
    timeUp: "Time for completing the survey has run out - your answers were saved.",
    errors: {
      required: "This field is required.",
      email: "Enter a valid e-mail address.",
      emailTaken: "This e-mail address is already taken.",
      questionRequired: "An answer to this question is required.",
      submit: "Could not save the survey. Please try again.",
    },
    nextFill: (date: string): string => `Next completion possible after ${date}`,
    remainingTime: (time: string): string =>
      `Time left to complete the survey: ${time}`,
    remainingQuestions: (remaining: number, percent: number): string => {
      const word = Math.abs(remaining) === 1 ? "question" : "questions";
      return `Questions left: ${remaining} ${word} (${percent}%)`;
    },
  },
  completed: {
    thankYou: "Thank you for completing the survey !!!",
    showResults: "View results",
    backToList: "Back to surveys",
  },
  score: {
    backToList: "Back to surveys",
    noData: "No results to display.",
    votes: "Number of votes",
    percent: "Percentage share",
  },
  formatNextFill: (raw: string): string => {
    const m = /^(\d{4})-(\d{2})-(\d{2})[ T](\d{2}):(\d{2})/.exec(raw);
    if (!m) return raw;
    return `${m[1]}-${m[2]}-${m[3]} ${m[4]}:${m[5]}`;
  },
};
